
export default [
  {
    url: "/",
    name: "Home",
    slug: "home",
    icon: "HomeIcon",
    permission : 'stats.read',
  },
  {
    name: "Partners",
    slug: "partners",
    icon: "BriefcaseIcon",
    permission : 'partners',
    submenu: [
      {
        url: '/admin/partners/list',
        name: 'List',
        slug: 'routes-list',
        permission : 'partners.read',
      },
      {
        url: '/admin/partners/add',
        name: 'Add',
        slug: 'routes-add',
        permission : 'partners.create',
      }
    ]
  },
  {
    url: "/admin/zones/list",
    name: "Zones",
    slug: "zones",
    icon: "FlagIcon",
    permission : 'zones',
  },
  {
    name: "Routes",
    slug: "routes",
    icon: "GitBranchIcon",
    permission : 'routes',
    submenu: [
      {
        url: '/admin/routes/list',
        name: 'List',
        slug: 'routes-list',
        permission : 'routes.read',
      },
      {
        url: '/admin/routes/add',
        name: 'Add Route',
        slug: 'routes-add',
        permission : 'routes.create',
      },
      {
        url: '/admin/routes/stations',
        name: 'Stations',
        slug: 'routes-stations',
        permission : 'stations.read',
      },
      {
        url: '/admin/routes/groups',
        name: 'Groups',
        slug: 'routes-groups',
        permission : 'routes.create',
      }
    ]
  },
  {
    name: "Vehicles",
    slug: "vehicles",
    icon: "TruckIcon",
    permission : 'vehicles',
    submenu: [
      {
        url: '/admin/vehicles/list',
        name: 'List',
        slug: 'vehicles-list',
        permission : 'vehicles.read',
      },
      {
        url: '/admin/vehicles/add',
        name: 'Add',
        slug: 'vehicles-add',
        permission : 'vehicles.create',
      }
    ]
  },
  {
    name: "Drivers",
    slug: "drivers",
    icon: "ListIcon",
    permission : 'drivers',
    submenu: [
      {
        url: '/admin/drivers/list',
        name: 'List',
        slug: 'driver-list',
        permission : 'drivers.read',
      },
      {
        url: '/admin/drivers/add',
        name: 'Add',
        slug: 'driver-add',
        permission : 'drivers.create',
      }
    ]
  },
  {
    name: "Trips",
    slug: "trips",
    icon: "MapIcon",
    permission : 'trips',
    submenu: [
      {
        url: '/admin/trips/list',
        name: 'List',
        slug: 'trips-list',
        permission : 'trips.read',
      },
      {
        url: '/admin/trips/add',
        name: 'Add',
        slug: 'trips-add',
        permission : 'trips.create',
      },
      {
        url: '/admin/trips/monitor',
        name: 'Monitor',
        slug: 'trips-monitor',
        permission : 'trips.monitor',
      },
    ]
  },
  {
    name: "Customers",
    slug: "customers",
    icon: "UsersIcon",
    permission : 'customers',
    submenu: [
      {
        url: '/admin/customers/list',
        name: 'List',
        slug: 'customer-list',
        permission : 'customers.read',
      },
      {
        url: '/admin/customers/orders',
        name: 'Orders',
        slug: 'orders-list',
      }
    ]
  },

  {
    name: "Coupons",
    slug: "coupons",
    icon: "TagIcon",
    permission : 'coupons',
    submenu : [
      {
        url: '/admin/coupons/list',
        name : 'List',
        slug: 'coupons-list',
        permission : 'coupons.read',
      },
      {
        url: '/admin/coupons/add',
        name : 'Add',
        slug: 'coupons-add',
        permission : 'coupons.create',
      }
    ]
  },

  {
    name: "Tools",
    slug: "tools",
    icon: "PaperclipIcon",
    permission : 'coupons',
    submenu : [
      {
        url: '/admin/tools/find',
        name : 'Find',
        slug: 'tools-find',
        permission : 'coupons.read',
      }
    ]
  },
]
